import { useForm } from '@mantine/form'
import { Button, Flex, LoadingOverlay, Paper, TextInput } from '@mantine/core'
import { Link } from 'react-router-dom'
import InputUserPosition from '../input/InputUserPosition'
import {
    IRequestUpdateProfile,
    IResponseGetProfile,
} from '@interfaces/api/IAuth'
import Auth from '@api/Auth'

const FormEditProfile = ({
    aftersuccess,
    data,
}: {
    aftersuccess?: () => any
    data: IResponseGetProfile
}) => {
    const form = useForm<IRequestUpdateProfile>({
        initialValues: {
            username: data.username ?? '',
            user_fullname: data.user_fullname ?? '',
            user_email: data.user_email ?? '',
            user_position_id: data.user_position_id,
        },
    })

    const { isLoading, onSubmit } = Auth.useUpdateProfile({
        form,
        aftersuccess: () => {},
    })

    return (
        <Paper pos='relative'>
            <LoadingOverlay visible={isLoading} overlayBlur={2} />
            <form onSubmit={onSubmit}>
                <Flex gap='sm' direction='column'>
                    <TextInput
                        withAsterisk
                        label='ชื่อจริงผู้ใช้งาน'
                        placeholder='ชื่อจริงผู้ใช้งาน'
                        {...form.getInputProps('user_fullname')}
                    />
                    <TextInput
                        label='อีเมล'
                        placeholder='อีเมล'
                        {...form.getInputProps('user_email')}
                    />
                    <InputUserPosition
                        {...form.getInputProps('user_position_id')}
                    />

                    <Flex mt='md' justify='end' gap='sm'>
                        <Button
                            component={Link}
                            to='/main'
                            variant='default'
                            w='fit-content'
                        >
                            กลับไปหน้าหลัก
                        </Button>
                        <Button type='submit' w='fit-content'>
                            บันทึกการแก้ไขโปรไฟล์
                        </Button>
                    </Flex>
                </Flex>
            </form>
        </Paper>
    )
}

export default FormEditProfile
